import { IPermissionModel } from './';

export const SSPermissions: IPermissionModel[] = [
	{ name: 'Dashboard', route: '/', components: ['lms-dashboard', 'bdese-ss-list', 'attendance-check'] },
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'PCMS', route: '/pcms', components: [] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },
	{ name: 'AllUsers', route: '/lms/users', components: ['newleads'] },
	{ name: 'Contractor360', route: '/lms/contractor', components: ['user-enrollment'] },
	{ name: 'AllSites', route: '/lms/sites', components: [] },
	{ name: 'CompetitionSites', route: '/lms/sites/competition', components: [] },
	{ name: 'UpcomingSites', route: '/lms/sites/upcoming', components: [] },
	{ name: 'AddNewSite', route: '/lms/add-new-site', components: [] },
	{ name: 'SiteInformation', route: '/lms/add-new-site/site-information', components: [] },
	{ name: 'MeetingDetails', route: '/lms/add-new-site/meeting-details', components: ['bdese-ss-dropdown'] },
	{ name: 'GlueDetails', route: '/lms/add-new-site/glue-details', components: [] },
	{ name: 'OtherInformation', route: '/lms/add-new-site/other-information', components: [] },
	{ name: 'ProductRecommendations', route: '/lms/product-recommendations', components: [] },
	{ name: 'SiteOverview', route: '/lms/site-overview', components: [] },
	{ name: 'SiteVisit', route: '/lms/site-visit', components: [] },
	{ name: 'MapView', route: '/lms/mapview', components: [] },
	{
		name: 'Contractor',
		route: '/contractor',
		components: ['tab-state', 'product-recommendation', 'has-not-kae', 'has-carpenter-permission'],
	},
	{ name: 'StaticDetails', route: '/contractor-KAE/static-details', components: [] },
	{ name: 'SiteLeadOverviewKAE', route: '/contractor-KAE/site-lead-overview', components: [] },
	{ name: 'DealerDetails', route: '/contractor/dealer-details', components: [] },
	{ name: 'ArchitectDetails', route: '/contractor/architect-details', components: [] },
	{ name: 'FpcStatus', route: '/contractor/fpc-status', components: [] },
	{ name: 'BankingDetails', route: '/contractor/banking-details', components: [] },
	{ name: 'Calculator', route: '/contractor/calculator', components: [] },
	{ name: 'CalculatorAdditionalDetails', route: '/contractor/calculator/calculator-details', components: [] },
	{ name: 'BankingHistory', route: '/contractor/banking-history', components: [] },
	{ name: 'PointsStatement', route: '/contractor/points-statement', components: [] },
	{ name: 'RedemptionHistory', route: '/contractor/redemption-history', components: [] },
	{ name: 'QrCodeScanner', route: '/contractor/qr-code-scanner', components: [] },
	{ name: 'QrCodeCheck', route: '/contractor/qr-code-check', components: [] },
	{ name: 'QrCodeValidate', route: '/contractor/qr-code-validate', components: [] },
	{ name: 'StaticDetails', route: '/contractor/static-details', components: [] },
	{ name: 'EditBasicDetails', route: '/edit-member-details/basic-details', components: ['ss-disable-button'] },
	{
		name: 'EditKycDetails',
		route: '/edit-member-details/kyc-details',
		components: ['bde-code-field', 'ss-disable-button'],
	},
	{
		name: 'EditMoreDetails',
		route: '/edit-member-details/more-details',
		components: ['bde-enroll-fnb-start-field', '901', '902', '903', '904', 'kae-carpenter-field', 'ss-disable-button'],
	},
];
